import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPeepBusinessCardInfo as GetPeepBusinessCardInfoQuery,
    GetPeepBusinessCardInfoVariables,
    PeepBusinessCardInfoFragment,
} from 'nutshell-graphql-types';

import GET_PEEP_BUSINESS_CARD_INFO from '../queries/get-peep-business-card-info.graphql';

export function useGetPeepBusinessCardInfo(
    entityId: string,
    skip: boolean = false
): {
    peepBusinessCardInfo: PeepBusinessCardInfoFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetPeepBusinessCardInfoQuery,
        GetPeepBusinessCardInfoVariables
    >(GET_PEEP_BUSINESS_CARD_INFO, {
        variables: {entityId},
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        peepBusinessCardInfo: data?.peep,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
